import type { ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'

interface Props {
  kicker: string
  title: string
  /** Tile controls (Pin/Export/vt-filter/coarsening). Marked data-export-skip — excluded from
   *  PNG/PDF capture while the kicker+title stay IN the captured element (spec D4). */
  actions?: ReactNode
}

export function ChartCardHeader({ kicker, title, actions }: Props) {
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="flex-end"
      sx={{ justifyContent: 'space-between' }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="eyebrow" color="text.secondary" sx={{ display: 'block' }}>
          {kicker}
        </Typography>
        <Typography
          variant="h6"
          component="h2"
          sx={{ lineHeight: 1.3 }}
          data-testid="chart-card-title"
        >
          {title}
        </Typography>
      </Box>
      {actions ? (
        <Stack direction="row" spacing={1} alignItems="center" data-export-skip="true">
          {actions}
        </Stack>
      ) : null}
    </Stack>
  )
}
